/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFEnumerationRecord } from './CRSFEnumerationRecord';
import {
    CRSFEnumerationRecordFromJSON,
    CRSFEnumerationRecordFromJSONTyped,
    CRSFEnumerationRecordToJSON,
} from './CRSFEnumerationRecord';

/**
 * 
 * @export
 * @interface CRSFEnumerationEvent
 */
export interface CRSFEnumerationEvent {
    /**
     * 
     * @type {string}
     * @memberof CRSFEnumerationEvent
     */
    fqdn: string;
    /**
     * 
     * @type {Array<CRSFEnumerationRecord>}
     * @memberof CRSFEnumerationEvent
     */
    records: Array<CRSFEnumerationRecord>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFEnumerationEvent
     */
    sources?: Array<string>;
}

/**
 * Check if a given object implements the CRSFEnumerationEvent interface.
 */
export function instanceOfCRSFEnumerationEvent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fqdn" in value;
    isInstance = isInstance && "records" in value;

    return isInstance;
}

export function CRSFEnumerationEventFromJSON(json: any): CRSFEnumerationEvent {
    return CRSFEnumerationEventFromJSONTyped(json, false);
}

export function CRSFEnumerationEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFEnumerationEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fqdn': json['fqdn'],
        'records': ((json['records'] as Array<any>).map(CRSFEnumerationRecordFromJSON)),
        'sources': !exists(json, 'sources') ? undefined : json['sources'],
    };
}

export function CRSFEnumerationEventToJSON(value?: CRSFEnumerationEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fqdn': value.fqdn,
        'records': ((value.records as Array<any>).map(CRSFEnumerationRecordToJSON)),
        'sources': value.sources,
    };
}

